export default __webpack_public_path__ + "static/media/favicon.66e0f9e3.ico";